import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export default function CallNow() {
  return (
    <motion.a
      href="tel:+393333202135"
      data-testid="call-now-button"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5, duration: 0.6 }}
      className="lg:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2.5 bg-gold text-ink font-semibold rounded-full pl-4 pr-5 py-3.5 shadow-[0_12px_32px_rgba(0,0,0,0.55)]"
    >
      <span className="relative flex items-center justify-center w-5 h-5">
        <span className="absolute inline-flex w-full h-full rounded-full bg-ink/25 animate-ping" />
        <Phone size={17} />
      </span>
      Chiama ora
    </motion.a>
  );
}
